import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Auth } from './model/auth.model';
import { Credential } from './model/credential.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthClientService {
  constructor(private http: HttpClient) {}

  public login(auth: Auth): Observable<Credential> {
    const data = {
      grantType: 'password',
      login: auth.username,
      password: auth.password,
      applicationScope: 'agent',
    };

    return this.http.post<Credential>(
      `${environment.auth.url}/auth/login`,
      data
    ).pipe(map((credential: any) => this.normalizeCredential(credential)));
  }

  public refresh(refreshToken: string): Observable<Credential> {
    return this.http.post<Credential>(`${environment.auth.url}/auth/refresh`, {
      refreshToken,
    }).pipe(map((credential: any) => this.normalizeCredential(credential)));
  }

  public loginWithSocial(provider: 'google' | 'apple' | 'facebook', token: string, email?: string): Observable<Credential> {
    return this.http.post<Credential>(`${environment.auth.url}/auth/login`, {
      grantType: provider,
      token,
      email,
      applicationScope: 'agent',
    }).pipe(map((credential: any) => this.normalizeCredential(credential)));
  }

  public resetPassword(data: any): Observable<any> {
    return this.http.post<any>(`${environment.auth.url}/users/forgot-password`,
      data
    );
  }

  public changePassword(data: any): Observable<any> {
    return this.http.put<any>(`${environment.auth.url}/users/password`,
      data
    );
  }

  public removeMyAccount(type: 'FULL_DELETE_AGENT' | 'REMOVE_ADMIN_PROFILE' | 'REMOVE_POLITICS_CONTEXT', userContextId?: string): Observable<any> {
    return this.http.request<any>('delete', `${environment.auth.url}/users/me/removal`, {
      body: {
        type,
        userContextId: userContextId || null,
      },
    });
  }

  private normalizeCredential(raw: any): Credential {
    if (!raw) {
      return raw;
    }

    const cometChat = raw.cometChat || raw.cometchat || raw.chat || {};
    const normalized: Credential = {
      ...raw,
      cometChatAuthToken:
        raw.cometChatAuthToken
        || raw.cometchatAuthToken
        || raw.comet_chat_auth_token
        || raw.cometChatToken
        || cometChat.authToken
        || cometChat.token,
      cometChatUid:
        raw.cometChatUid
        || raw.cometchatUid
        || raw.comet_chat_uid
        || raw.chatUid
        || cometChat.uid
        || cometChat.userId,
    };

    return normalized;
  }

}
